export const companyGroupsKey = ['companyGroups']
